module.exports = __webpack_public_path__ + "media/img/referrals/banner-0267b156cde2fa6434804b121fc0598a.png";